import Vue from 'vue'
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue'
import HighchartsMore from 'highcharts/highcharts-more'

HighchartsMore(Highcharts);

Highcharts.setOptions({
    lang: {
        numericSymbols: undefined
    }
});

Vue.use(HighchartsVue)